import(/* webpackMode: "eager", webpackExports: ["Button"] */ "/app/front_end/node_modules/@headlessui/react/dist/components/button/button.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/front_end/node_modules/next-intl/dist/esm/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/app/front_end/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/app/front_end/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/front_end/src/app/(main)/(leaderboards)/leaderboard/components/project_leaderboard_table/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/front_end/src/app/(main)/(tournaments)/tournament/components/dropdown_menu.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/front_end/src/app/(main)/(tournaments)/tournament/components/index/index_questions_table.tsx");
;
import(/* webpackMode: "eager" */ "/app/front_end/src/app/(main)/(tournaments)/tournament/components/index/styles.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/front_end/src/app/(main)/(tournaments)/tournament/components/members/members_invite.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/front_end/src/app/(main)/(tournaments)/tournament/components/members/members_manage.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/front_end/src/app/(main)/(tournaments)/tournament/components/tournament_feed.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/front_end/src/app/(main)/(tournaments)/tournament/components/tournament_subscribe_button.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/front_end/src/components/html_content/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/front_end/src/components/refresh_button.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/front_end/src/components/tournament_filters.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/front_end/src/components/ui/info_toggle.tsx");
;
import(/* webpackMode: "eager" */ "/app/front_end/src/components/ui/section_toggle.tsx");
